import React from 'react';
import { STAGE_LABELS, CanonicalStage } from '../../../lib/workflow/transitions';

interface StageFocusSectionProps {
  stage: string;
  title: string;
  children: React.ReactNode;
}

/**
 * Highlights the application section relevant to the current workflow stage
 * (refined spec 2026-10-11).
 *
 * The gate panel (checklist) and this surfaced section are linked — the admin
 * sees the checklist AND the data it refers to without hunting through tabs.
 * The embedded content must be FULLY FUNCTIONAL (not a read-only summary):
 * the admin does the work right here in the drawer, reusing the existing
 * functional components.
 */
export default function StageFocusSection({ stage, title, children }: StageFocusSectionProps) {
  const stageLabel = (STAGE_LABELS as any)[stage as CanonicalStage] || stage;
  return (
    <section
      aria-label={`Current stage focus: ${title}`}
      className="rounded-2xl border-2 border-blue-500 bg-blue-50/40 shadow-[0_0_0_4px_rgba(59,130,246,0.08)] overflow-hidden"
    >
      <div className="flex items-center gap-2 bg-blue-600 px-4 py-2">
        <span className="inline-flex items-center rounded-full bg-white/20 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white">
          Current stage
        </span>
        <h3 className="text-[13px] font-extrabold text-white">
          {title} <span className="font-medium text-blue-100">· {stageLabel}</span>
        </h3>
      </div>
      <div className="p-3 sm:p-4 bg-white/80">{children}</div>
    </section>
  );
}
